import React, { useState, useEffect } from "react";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { Form, Col } from "react-bootstrap";
import SomeSpinner from "components/Somespinner/Somespinner.js"

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";

import { makeStyles } from "@material-ui/core/styles";

import Button from "components/CustomButtons/Button.js";

import api from "assets/services/api.js";
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";

import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";
import { formatDateFilter, formatDate } from "services/formatDate.js"
import 'bootstrap/dist/css/bootstrap.min.css';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    ftsize: {
        fontSize: "12.6px!important"
    },
    widthSelect: {
        width: "90%",
        marginTop: "10px"
    }
};


const useStyles = makeStyles(styles);

export default function Comission() {

    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const [sellsmanId, setSellsmanId] = useState();
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [br2, setBR2] = useState(false);
    const [sellsmans, setSellsmans] = useState([]);
    const [controlSnackReady, setControlSnackReady] = useState(false);

    useEffect(() => {
        if (controlSnackReady) { showNotificationReady("br") }
    }, [controlSnackReady]);

    useEffect(() => {
        loadSellsman();
    }, []);


    const { storageId } = useAuth();

    const classes = useStyles();

    async function download() {
        let id;
        sellsmanId ? id = sellsmanId : id = sellsmans[0].id;
        const id_sellsman = sellsmans.filter(sellsman => parseInt(sellsman.id) === parseInt(id));
        const sellsman = id_sellsman[0].name;

        await api.get('/sell/admin/download/for/comission/' + id, { responseType: 'blob' }).then(function (response) {
            let blob = new Blob([response.data], {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                }
            });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Comissão de ${sellsman} - ${formatDate(startDate)} à ${formatDate(endDate)}.pdf`;
            link.click();
        })
            .catch(function (error) {
                console.log(error)
            });
    }
    async function download2() {

    }

    async function loadSellsman() {
        const response = await api.get('sellsman/admin/type/all/' + storageId)
        setSellsmans(response.data);
    }

    async function downloadSummary() {
        await api.get('/sell/admin/download/comission/summary/' + storageId, { responseType: 'blob' }).then(function (response) {
            let blob = new Blob([response.data], {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                }
            });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Resumo de comissões - ${formatDate(startDate)} à ${formatDate(endDate)}.pdf`;
            link.click();
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    async function generateSummary() {
        if (startDate > endDate) {
            alert('Interválo de datas inválido');
            return;
        }
        if (startDate && endDate) {
            setLoading(true);
            const response = await api.get('/sell/generate/admin/comission/summary/' + storageId + '/' + formatDateFilter(startDate) + '/' + formatDateFilter(endDate));
            response.status === 200 ? downloadSummary() : download2();
            setControlSnackReady(true);
            setLoading(false);
        } else {
            alert('Insira a data para gerar o resumo');
        }
    }

    async function generateAllRecursive(index) {
        if (index >= sellsmans.length) {
            setLoading(false);
            setControlSnackReady(true);
            return;
        }
        const sellsman = sellsmans[index];
        try {
            const response = await api.get('/sell/generate/admin/for/comission/' + sellsman.id + '/' + formatDateFilter(startDate) + '/' + formatDateFilter(endDate));
            if (response.status === 200) {
                await api.get('/sell/admin/download/for/comission/' + sellsman.id, { responseType: 'blob' }).then(function (res) {
                    let blob = new Blob([res.data], {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/pdf',
                        }
                    });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Comissão de ${sellsman.name} - ${formatDate(startDate)} à ${formatDate(endDate)}.pdf`;
                    link.click();
                });
            }
        } catch (error) {
            console.log(error);
        }
        await generateAllRecursive(index + 1);
    }

    async function generateAll() {
        if (startDate > endDate) {
            alert('Interválo de datas inválido');
            return;
        }
        if (startDate && endDate) {
            setLoading(true);
            await generateAllRecursive(0);
        } else {
            alert('Insira a data para gerar os relatórios');
        }
    }

    async function generatePdf() {
        if (startDate > endDate) {
            alert('Interválo de datas inválido');
        }
        if (startDate && endDate) {
            setLoading(true);
            let id;
            sellsmanId ? id = sellsmanId : id = sellsmans[0].id
            const response = await api.get('/sell/generate/admin/for/comission/' + id + '/' + formatDateFilter(startDate) + '/' + formatDateFilter(endDate));
            response.status === 200 ? download() : download2();
            setControlSnackReady(true);
            setLoading(false);
        }
        else {
            alert('Insira a data para gerar o relatório');
        }
    }


    const showNotificationReady = place => {
        switch (place) {
            case "br":
                if (!br2) {
                    setBR2(true);
                    setTimeout(function () {
                        setBR2(false);
                        setControlSnackReady(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>today</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> de data primária</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <DatePicker className={classes.marginDate}
                            selected={startDate}
                            onChange={date => setStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            locale={pt}
                            disabledKeyboardNavigation />
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>event</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> de data primária </p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <DatePicker className={classes.marginDate}
                            selected={endDate}
                            onChange={date => setEndDate(date.withoutTime())}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            locale={pt}
                            disabledKeyboardNavigation />
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} md={12} sm={12}>
                {loading ?
                    <div>
                        <SomeSpinner />
                    </div> :
                    <div></div>
                }
                <Card>
                    <CardHeader className={classes.zindex} color="primary">
                        <h4 className={classes.cardTitleWhite}>Vendedores</h4>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        <Form.Row className={classes.widthSelect} >
                            <Form.Group as={Col} controlId="formGridSellsman">
                                <Form.Control onChange={event => setSellsmanId(event.target.value)} value={sellsmanId} as="select" defaultValue="Choose...">
                                    {sellsmans.map(sellsman => (
                                        <option key={String(sellsman.id)} value={sellsman.id}>{sellsman.name + " " + sellsman.lastname}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Form.Row>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>

                        <Button color="success" onClick={generatePdf}>
                            Gerar comissão
                        </Button>
                        <Button color="info" onClick={generateSummary}>
                            Resumo de comissões
                        </Button>
                        <Button color="warning" onClick={generateAll}>
                            Baixar todos
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <Snackbar
                place="br"
                color="success"
                icon={AddAlert}
                message="Comissão gerada com sucesso"
                open={br2}
                closeNotification={() => setBR2(false)}
                close
            />
        </GridContainer>
    );
}